import React, { useState, useEffect } from 'react';
import { Switch, useHistory, Route } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import Page404 from '../components/Layout/Page404';
import LandingPage from '../components/Layout/LandingPage';
import Verification from '../pages/Verification/Verification';
import Search from '../pages/Search/Search';
import EventVerification from '../pages/EventVerification/EventVerification';
import EventCreation from '../pages/EventCreation/EventCreation';
import EventManager from '../pages/EventManager/EventManager';
import AdjusterInfoEntry from '../pages/AdjusterInfoEntry/AdjusterInfoEntry';
import NoEvent from '../pages/NoEvent/NoEvent';
import AddEditEvent from '../pages/EventManager/AddEditEvent';
import EventUserList from '../pages/EventManager/EventUserList';
import { IsNullOrEmpty } from './Common';
import {
  IdleTimer,
  IdleTimerProvider,
  IdleTimerConsumer,
  IIdleTimerContext,
  IdleTimerContext,
  useIdleTimerContext
} from 'react-idle-timer'
import moment from 'moment';
import { use } from 'react';
import { SetMealSharp } from '@mui/icons-material';

function Routes(params) {
  const storageRoles = localStorage.getItem('roles');
  const roles = storageRoles ? storageRoles.split(',') : [];
  const [loading, setLoading] = useState(true);
  const [userMode, setUserMode] = useState('');
  const [isManagerlogin, setIsManagerlogin] = useState(false);
  const history = useHistory();
  const getRoles = async () => {
    setLoading(true);
    await fetch(`/.auth/me`)
      .then(res => {
        res.json().then(resJson => {
          setLoading(false);
          const { clientPrincipal } = resJson;
          console.log(clientPrincipal);
          localStorage.setItem('roles', JSON.stringify(clientPrincipal?.userRoles));
          localStorage.setItem('pilotId', JSON.stringify(clientPrincipal?.userDetails));
          localStorage.setItem('loginUserName', clientPrincipal?.claims?.filter(x => x.typ == 'name').map(x => x.val).toString().split(' ').slice(0)[0].trim());
          getUserRole();
        })
      });
  };

  useEffect(() => {
    getRoles();
  }, []);

  useEffect(() => {
    getRoles();
  }, [history]);

  const getUserRole = () => {
    const roles = localStorage.getItem("roles")?.split(",") || [];
    const hasAccess = roles.some((role) => role?.toLowerCase().includes("checkinappuser")
      || role?.toLowerCase().includes("checkinappappuser")
      || role?.toLowerCase().includes("checkinappadmin"))
    if (hasAccess) {
      setIsManagerlogin(true);
    }
    if (!hasAccess && IsNullOrEmpty(localStorage.getItem('defaultEventId')) && ['/Search', '/AdjusterInfoEntry', '/Verification', '/EventVerification', '/'].includes(history.location.pathname)) {
      history.push('/NoEvent');
    }
  }

  const idleTimerRef = React.useRef(null);

  const on24HoursIdle = () => {
    //console.log('24 hours idle');
    ResetSessionVariables();
  }

  const on4HoursIdle = () => {
    //console.log('4 hours idle');
    ResetSessionVariables();
    //We are using this function to control user session mode 
    //The manager is not logged in but redirect to logout will redirect them to noevent page
    //Since the session times out, the manager will have to log in to start a new session
  }

  const ResetSessionVariables = () => {
    localStorage.setItem('defaultEventId', "");
    localStorage.setItem('roles', "");
    localStorage.setItem('pilotId', "");
    localStorage.setItem('loginUserName', "");
    localStorage.setItem('JWTToken', "");
    window.location.replace("/logout");
  }

  useEffect(() => {
    console.log('isManagerlogin:::', isManagerlogin);
    if (!isManagerlogin) {
      let ThreeHours59Minutes50Seconds = 14395000; // 3 hours, 59 minutes, and 50 seconds in milliseconds
      //we put a 10 seconds buffer to renew the token before it expires
      const interval = setInterval(() => {
        if (localStorage.getItem('JWTToken') !== null && localStorage.getItem('JWTToken').length > 0) {
          RenewJWTToken();
        }
      }, ThreeHours59Minutes50Seconds);

      return () => {
        clearInterval(interval);
      };
    }
  }, [isManagerlogin]);

  const RenewJWTToken = () => {
    try {
      fetch(`/api/Auth/RenewJwtToken`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('JWTToken')}`,
          'Content-Type': 'application/json',
        }
      })
        .then((response) => response.json())
        .then((data) => {
          localStorage.setItem('JWTToken', data.token);
          //console.log('Token Renewed');
        })
        .catch((error) => {
          ResetSessionVariables();
          //console.log("Error fetching data: ", error);
        });
    } catch (ex) {
      ResetSessionVariables();
      //console.log("Error fetching data: ", ex?.message);
    }
  }

  const onAction = (event) => {
    localStorage.setItem('lastActiveTime', new Date().toLocaleString());
    //console.log('user is on action', event)
  }


  var RoutesComponent = () =>
    <Route>
      <Layout timeout={params.timeout}>
        <Switch>
          <Route exact path="/" render={(props) => { return <LandingPage {...props} />; }}></Route>
          <Route exact path="/Verification" render={(props) => { return <Verification {...props} />; }}></Route>
          <Route exact path="/Search" render={(props) => { return <Search {...props} />; }}></Route>
          <Route exact path="/EventVerification" render={(props) => { return <EventVerification {...props} />; }}></Route>
          <Route exact path="/EventCreation" render={(props) => { return <EventCreation {...props} />; }}></Route>
          <Route exact path="/EventManager" render={(props) => { return <EventManager {...props} />; }}></Route>
          <Route exact path="/AdjusterInfoEntry" render={(props) => { return <AdjusterInfoEntry {...props} />; }}></Route>
          <Route exact path="/NoEvent" render={(props) => { return <NoEvent {...props} />; }}></Route>
          <Route exact path="/AddEditEvent" render={(props) => { return <AddEditEvent {...props} />; }}></Route>
          <Route exact path="/EventUserList" render={(props) => { return <EventUserList {...props} />; }}></Route>
          <Route exact path="/api/Event/GetAllEventsSorted" render={(props) => { return <EventManager {...props} />; }}></Route>
          <Route path='/logout' render={(props) => { return <Search {...props} />; }} />
          <Route path='/.auth/login/aad' />
          <Route path="*" component={Page404} />
        </Switch>
      </Layout>
    </Route>;

  if (loading) {
    return null;
  }
  else {
    return (
      <>
        {roles &&
          roles.length > 0 &&
          roles.find(
            (role) => role?.toLowerCase().includes("checkinappuser")
              || role?.toLowerCase().includes("checkinappappuser")
              || role?.toLowerCase().includes("checkinappadmin"))
          ?
          <IdleTimerProvider
            timeout={24 * 60 * 60 * 1000} //24 hours for manager          
            onIdle={on24HoursIdle}
          >
            <RoutesComponent />
          </IdleTimerProvider> :
          <IdleTimerProvider
            timeout={15 * 60 * 60 * 1000} //15 hours for user  
            //timeout={60 * 1000}
            onIdle={on4HoursIdle}
            onAction={onAction}
          >
            <RoutesComponent />
          </IdleTimerProvider>
        }
      </>
    );
  }

}

export default Routes;

